import { Box } from "@mui/material";
import { CSSProperties, FC, useContext } from "react";
import { GoogleServicesContext } from "../../context/GoogleServicesContext";
import { colors } from "../../theme/colors";
import { gaAction, gaCategory } from "../../utils/analytics";
import Button, { ButtonProps } from "./Button";

type SocialButtonProps = {
  network: "facebook" | "instagram";
  link?: string;
  logoSrc?: string;
  logoAlt?: string;
} & ButtonProps;

const SocialLogo = ({
  logoSrc,
  logoAlt,
  network
}: {
  logoSrc?: string;
  logoAlt?: string;
  network: string;
}) => (
  <Box
    component="img"
    sx={(theme) => ({ width: theme.spacing(6), height: theme.spacing(6) })}
    src={logoSrc}
    alt={logoAlt}
    title={network}
  />
);

const SocialButton: FC<SocialButtonProps> = ({ network, link, logoSrc, logoAlt, ...props }) => {
  const { analyticsEvent } = useContext(GoogleServicesContext);

  let sx: CSSProperties = {
    width: "100%"
  };

  switch (network) {
    case "facebook":
      sx = {
        ...sx,
        background: `linear-gradient(84deg, ${colors.facebook1} 0%, ${colors.facebook2} 100%)`
      };
      break;
    case "instagram":
      sx = {
        ...sx,
        background: `linear-gradient(84deg, ${colors.instagram1} 0%, ${colors.instagram2} 100%)`
      };
      break;
  }

  return (
    <Button
      {...props}
      component="a"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={network}
      sx={sx}
      onClick={() => analyticsEvent(gaCategory.social, gaAction.click, network)}>
      <SocialLogo logoSrc={logoSrc} logoAlt={logoAlt} network={network} />
    </Button>
  );
};

export default SocialButton;
